import Loading from '@virtus/components/Loading/Loading';
import React from 'react';
import 'src/formcontrols/hoc/PopupModal/ModalContent.css';
import * as ColorPalette from 'src/formcontrols/Themes/theme';
import './ModalContent.css';

interface IProps {
  isLoading: boolean;
  children?: React.ReactNode;
}
const style = {
  backgroundColor: ColorPalette.colors.bgDark,
  padding: '20px',
};

class ModalContent extends React.Component<IProps> {
  public render() {
    return (
      <div className="modal-content" style={style}>
        {this.props.isLoading ? <Loading loading={true} /> : this.props.children}
      </div>
    );
  }
}

export default ModalContent;
